import * as React from 'react'

function IconTeacher_2(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={68}
      height={68}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={34} cy={34} r={34} fill="#F4BA27" fillOpacity={0.5} />
      <path
        d="M37.902 7.18a2.518 2.518 0 01-1.638-.301c-2.34-1.36-9.961-4.766-17.124 3.347-7.111 8.053-9.075 22.251-13.438 30.615-1.473 2.826-.564 6.309 2.123 8.018 8.798 5.588 27.287 15.051 44.704 9.407 2.39-.775 4.031-2.974 4.161-5.484.635-12.244.883-48.54-18.788-45.602z"
        fill="#fff"
      />
      <path
        d="M57.237 41.534c-.382 2.66-2.886 4.582-5.55 4.258a5.583 5.583 0 01-.408-.066c-1.24-.255-2.515.208-3.264 1.227-4.475 6.088-11.757 8.43-18.495 7.432-6.777-1.208-12.993-5.83-15.246-13.15a2.79 2.79 0 00-2.43-1.96 5.829 5.829 0 01-.262-.027c-2.65-.351-4.601-2.808-4.326-5.47a5.005 5.005 0 015.784-4.434l.01.002c.518.086 1.018-.223 1.137-.734 3.229-14 13.453-19.72 22.516-18.309 9.032 1.54 16.905 10.207 15.535 24.491-.05.527.32 1.003.842 1.088l.01.002a5.006 5.006 0 014.147 5.65z"
        fill="#fff"
      />
      <path
        d="M50.682 39.905a.355.355 0 01-.126-.657c.089-.054 2.226-1.307 5.28-.05a.356.356 0 11-.272.658c-2.709-1.11-4.566-.043-4.643.002a.339.339 0 01-.24.047z"
        fill="#fff"
      />
      <path
        d="M54.817 41.529a.354.354 0 01-.266-.2c-.74-1.566-2.14-1.925-2.2-1.939a.356.356 0 01.164-.693c.072.017 1.788.442 2.68 2.327a.357.357 0 01-.378.505zM14.549 34.008a.357.357 0 01-.213-.12c-.06-.07-1.481-1.675-4.402-1.48a.353.353 0 01-.378-.333.355.355 0 01.331-.379c3.296-.221 4.924 1.647 4.992 1.727a.357.357 0 01-.33.585z"
        fill="#fff"
      />
      <path
        d="M10.112 34.231a.358.358 0 01-.2-.6c1.444-1.503 3.206-1.362 3.28-1.356.197.014.34.193.322.389a.355.355 0 01-.386.322c-.063-.006-1.505-.109-2.702 1.138a.348.348 0 01-.314.107zM32.38 40.617a.356.356 0 01-.056-.69c1.107-.376 1.736-.757 1.87-1.132.122-.341-.166-.806-.5-1.344-.201-.326-.43-.693-.605-1.099-.788-1.82.705-7.962.877-8.655a.362.362 0 01.433-.26.36.36 0 01.26.433c-.452 1.822-1.5 6.847-.916 8.2.154.356.36.686.557 1.007.414.666.804 1.293.565 1.96-.22.615-.934 1.097-2.312 1.567a.352.352 0 01-.172.013zM32.98 43.785c-3.65-.596-3.67-3.94-3.67-3.974a.356.356 0 11.713.006c0 .12.033 2.85 3.198 3.287.177.029.33.208.303.402a.356.356 0 01-.402.303l-.142-.024zM43.48 37.099c.158-.971-.16-1.831-.712-1.921-.55-.09-1.126.624-1.284 1.595-.159.97.16 1.83.711 1.92.551.09 1.127-.623 1.285-1.594zM25.034 34.089c.159-.971-.16-1.831-.711-1.921-.551-.09-1.126.624-1.285 1.595-.158.97.16 1.83.712 1.92.551.09 1.126-.623 1.284-1.594zM42.807 44.852c2.22-.479 3.787-1.95 3.5-3.284-.288-1.335-2.321-2.029-4.541-1.55-2.22.48-3.787 1.95-3.5 3.285.288 1.335 2.321 2.028 4.541 1.55zM25.93 41.291c.696-1.174-.323-3.067-2.276-4.227-1.953-1.16-4.1-1.15-4.797.025-.697 1.174.322 3.067 2.275 4.227 1.953 1.16 4.1 1.15 4.797-.025z"
        fill="#fff"
      />
      <path
        d="M12.318 24.193c19.12 3.26 23.857-4.073 23.857-4.073s4.827 5.699 17.067 10.036l-1.023-13.04-12.41-8.63-15.66.745-11.83 14.962z"
        fill="#fff"
      />
      <path
        d="M20.994 29.123a.358.358 0 01-.223-.573c.031-.041 3.216-4.005 7.736-2.065a.357.357 0 01-.282.655c-4.01-1.725-6.777 1.703-6.893 1.85a.351.351 0 01-.338.133zM47.129 33.208a.357.357 0 01-.28-.232c-.064-.176-1.599-4.306-5.948-3.946a.357.357 0 01-.058-.71c4.9-.405 6.66 4.369 6.678 4.416a.356.356 0 01-.392.472z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconTeacher_2
